import type { CrewBitConfig } from '../../types/configExport';

export interface StarterPackMeta {
  id: string;
  name: string;
  description: string;
  industry: string;
  serviceCount: number;
}

export const STARTER_PACKS: StarterPackMeta[] = [
  { id: 'nail_salon', name: 'Nail salon', description: '15 services, salon hours, commission defaults', industry: 'beauty', serviceCount: 15 },
  { id: 'barbershop', name: 'Barbershop', description: '12 services, walk-in hours, chair config', industry: 'beauty', serviceCount: 12 },
  { id: 'plumbing', name: 'Plumbing', description: '10 services, field service hours', industry: 'home_services', serviceCount: 10 },
  { id: 'cleaning', name: 'Cleaning', description: '8 services, route-based hours', industry: 'cleaning', serviceCount: 8 },
  { id: 'landscaping', name: 'Landscaping', description: '10 services, seasonal scheduling', industry: 'landscaping', serviceCount: 10 },
  { id: 'property', name: 'Property management', description: '8 services, inspection defaults', industry: 'property', serviceCount: 8 },
  { id: 'fitness', name: 'Fitness studio', description: '10 services, extended hours', industry: 'wellness', serviceCount: 10 },
  { id: 'automotive', name: 'Automotive', description: '10 services, shop hours', industry: 'automotive', serviceCount: 10 },
];

export async function loadStarterPack(id: string): Promise<CrewBitConfig | null> {
  switch (id) {
    case 'nail_salon': return (await import('./nailSalon')).nailSalonPack;
    case 'barbershop': return (await import('./barbershop')).barbershopPack;
    case 'plumbing': return (await import('./plumbing')).plumbingPack;
    case 'cleaning': return (await import('./cleaning')).cleaningPack;
    case 'landscaping': return (await import('./landscaping')).landscapingPack;
    case 'property': return (await import('./propertyManagement')).propertyManagementPack;
    case 'fitness': return (await import('./fitnessStudio')).fitnessStudioPack;
    case 'automotive': return (await import('./automotive')).automotivePack;
    default: return null;
  }
}
